module.exports = __webpack_public_path__ + "img/list_image.2ab7ffbd.png";